<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="background: linear-gradient(60deg,#66bb6a,#43a047); color: white;"
    >
      <span
        style="font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;"
        >{{
          $t("commonWords.create") +
            " " +
            $t("commonWords.newF") +
            " " +
            $t("commonWords.intent")
        }}</span
      >
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('close-create-dialog')"
        class="md-simple md-just-icon"
      >
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <form class="form-horizontal">
          <div class="md-layout">
            <div class="textLabel colorDark" style="margin-top: 12px;">
              {{ $t("intentCreate.name") }}
            </div>
            <div class="textLabel colorGrey">
              {{ $t("intentCreate.textName") }}
            </div>
            <md-field style="margin-top: 0;">
              <md-icon>#</md-icon>
              <md-input
                v-model="intent.intent"
                :placeholder="$t('intentCreate.nameLabel')"
              ></md-input>
            </md-field>
            <div class="textLabel colorDark" style="margin-top: 20px;">
              {{ $t("intentCreate.description") }}
            </div>
            <md-field style="margin-top: 0;">
              <md-input
                v-model="intent.description"
                :placeholder="$t('intentCreate.descriptionLabel')"
              ></md-input>
            </md-field>

            <div style="width: 100%;">
              <div
                class="md-layout"
                style="width: 100%; justify-content: flex-end"
              >
                <md-button
                  @click="saveNewIntent()"
                  class="md-success"
                >
                  <span>{{ $t("commonWords.create") }}</span>
                </md-button>
              </div>
            </div>
          </div>
        </form>
      </md-card-content>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      intent: {}
    }
  },
  methods: {
    saveNewIntent () {
      this.$emit('save', this.intent)
      this.$emit('close-create-dialog')
      this.clear()
    },
    clear () {
      this.intent = {
        intent: '',
        description: '',
        examples: []
      }
    }
  },
  created () {
    this.clear()
  }
}
</script>

<style scoped>
.md-button.md-simple i {
  color: white !important;
}
.textLabel {
  width: 100%;
  font-size: 14px;
  line-height: 24px;
}
.colorDark {
  color: #393939;
}
.colorGrey {
  color: rgba(111, 111, 111, 0.603);
}
</style>
